import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import Moment from 'react-moment';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { formatPontos } from '../../util/numberUtil';

export class ModalDetalhamentoFinanceiroCliente extends Component {
    constructor(props) {
        super(props);
        this.state = { extrato: [], carregando: false };
        this.fecharModal = this.fecharModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.cliente && this.props.cliente !== prevProps.cliente) {
            this.carregarExtrato(this.props.cliente.id);
        }
    }

    carregarExtrato(clienteId) {
        this.setState({ carregando: true, extrato: [] });
        axios.get(`${URL}/cliente/${clienteId}/extrato-pontos`, SLOW_REQUEST_CONFIG)
            .then(resp => this.setState({ extrato: resp.data || [] }))
            .catch(() => this.setState({ extrato: [] }))
            .finally(() => this.setState({ carregando: false }));
    }

    fecharModal() {
        $('#modalDetalhamentoFinanceiroCliente').modal('hide');
        $('#modalDetalhamentoFinanceiroCliente').hide();
        $('.modal-backdrop').hide();
        this.setState({ extrato: [] });
    }

    render() {
        const { cliente } = this.props;
        const { extrato, carregando } = this.state;

        return (
            <div className="modal fade show" id="modalDetalhamentoFinanceiroCliente" role="dialog"
                aria-labelledby="modalDetalhamentoFinanceiroCliente" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content vx-modal-content">

                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">account_balance_wallet</i>
                                <span className="vx-modal-title">
                                    Extrato de Pontos{cliente ? ` — ${cliente.nome}` : ''}
                                </span>
                            </div>
                            <button type="button" className="vx-modal-close" onClick={this.fecharModal}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        <div className="vx-modal-body">
                            {cliente && (
                                <>
                                    {/* Resumo de saldo */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
                                        <div style={{ background: 'rgba(40,167,69,0.07)', border: '1px solid rgba(40,167,69,0.2)', borderRadius: 10, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <i className="material-icons" style={{ fontSize: 32, color: '#28a745' }}>star</i>
                                            <div>
                                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', fontWeight: 600 }}>Pontos Disponíveis</div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e7e34' }}>{formatPontos(cliente.pontosDisponiveis)}</div>
                                            </div>
                                        </div>
                                        <div style={{ background: 'rgba(220,53,69,0.06)', border: '1px solid rgba(220,53,69,0.18)', borderRadius: 10, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <i className="material-icons" style={{ fontSize: 32, color: '#dc3545' }}>lock</i>
                                            <div>
                                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', fontWeight: 600 }}>Pontos Congelados</div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#c62828' }}>{formatPontos(cliente.pontosCongelados)}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Extrato */}
                                    <div style={{ fontWeight: 700, fontSize: 13, color: '#333', marginBottom: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                        Histórico de Movimentações
                                    </div>
                                    {carregando ? (
                                        <div className="vx-empty-state">
                                            <i className="material-icons">hourglass_empty</i>
                                            <p>Carregando extrato...</p>
                                        </div>
                                    ) : extrato.length > 0 ? (
                                        <div className="vx-table-scroll">
                                            <table className="vx-table-left">
                                                <thead>
                                                    <tr>
                                                        <th>Data</th>
                                                        <th>Descrição</th>
                                                        <th>Tipo</th>
                                                        <th>Pontos</th>
                                                        <th>Saldo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {extrato.map((e, i) => (
                                                        <tr key={i}>
                                                            <td><Moment format="DD/MM/YYYY HH:mm">{e.dataMovimentacao}</Moment></td>
                                                            <td>{e.descricao}</td>
                                                            <td>
                                                                <span style={{
                                                                    padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 700,
                                                                    background: e.tipo === 'CREDITO' ? 'rgba(40,167,69,0.12)' : 'rgba(220,53,69,0.10)',
                                                                    color: e.tipo === 'CREDITO' ? '#1e7e34' : '#c62828',
                                                                }}>
                                                                    {e.tipo === 'CREDITO' ? '+ Crédito' : '- Débito'}
                                                                </span>
                                                            </td>
                                                            <td style={{ fontWeight: 700, color: e.tipo === 'CREDITO' ? '#1e7e34' : '#c62828' }}>
                                                                {e.tipo === 'CREDITO' ? '+' : '-'}{formatPontos(e.quantidade)}
                                                            </td>
                                                            <td>{formatPontos(e.saldoApos)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="vx-empty-state" style={{ padding: '30px 0' }}>
                                            <i className="material-icons">receipt_long</i>
                                            <p>Nenhuma movimentação registrada.</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        <div className="vx-modal-footer">
                            <button type="button" className="vx-btn-secondary" onClick={this.fecharModal}>
                                Fechar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ModalDetalhamentoFinanceiroCliente;
